"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "35",
    height: "35",
    viewBox: "0 0 35 35"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.5,0A17.5,17.5,0,1,0,35,17.5,17.51,17.51,0,0,0,17.5,0Zm6.73,20.75-5.78,5.78a1.35,1.35,0,0,1-1.9,0l-5.78-5.78a1.34,1.34,0,1,1,1.9-1.9l3.48,3.48V9.42a1.35,1.35,0,0,1,2.7,0V22.33l3.48-3.48a1.34,1.34,0,1,1,1.9,1.9Z"
  }));
};

exports["default"] = _default;